import { useContextStore } from '@/stores/context';
import to from 'await-to-js';
import axios from 'axios';
import { keys } from 'lodash';
import { defineStore } from 'pinia';
import { computed, ref, shallowRef } from 'vue';

export const useReportingPowerBiStore = defineStore('reporting-power-bi', () => {
  const contextStore = useContextStore();
  // State
  const embedToken = ref(null);
  const loading = shallowRef(false);

  // Getters
  const availableReports = computed(() => {
    return new Set(keys(contextStore.powerBIreportIds));
  });

  async function fetchEmbedToken(reportName) {
    const [error, response] = await to(
      axios.get(`/api/reporting-power-bi/embedToken/${reportName}`)
    );

    loading.value = false;

    if (error) {
      // TODO: commented code, no handleResponseNotifications from vue2
      // dispatch('handleResponseNotifications', {
      //   error,
      //   errorMessage: i18n.t('notifications.fetchError', {
      //     resource: i18n.t('entities.report'),
      //   }),
      // });
    }
    return response.data;
  }

  function setLoading(isLoading) {
    loading.value = isLoading;
  }

  function setEmbedToken(token) {
    embedToken.value = token;
  }

  return {
    embedToken,
    loading,
    availableReports,
    fetchEmbedToken,
    setLoading,
    setEmbedToken,
  };
});
